"use client";

import { useEffect, useState } from "react";

interface ClientDesktopOnlyProps {
  children: React.ReactNode;
  minWidth?: number; // Minimum width to render (optional, default: 992px)
}

const ClientDesktopOnly: React.FC<ClientDesktopOnlyProps> = ({ children, minWidth = 992 }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsClient(window.innerWidth >= minWidth);
    };

    handleResize(); // Run on mount
    window.addEventListener("resize", handleResize); // Listen for window resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, [minWidth]);

  return isClient ? <>{children}</> : null;
};

export default ClientDesktopOnly;
